<template>
  <FollowRecommend v-if="memberId !== userStore.memberId && itemId && itemStore.likedItemIds.includes(itemId)" :member-id="memberId" placement="bottom-end" />
</template>

<script setup lang="ts">
import { useItemStore } from '@/js/lib/store/item';
import { useUserStore } from '@/js/lib/store/user';
import FollowRecommend from './FollowRecommend.vue';

withDefaults(
  defineProps<{
    itemId?: number;
    memberId: number;
  }>(),
  {
    itemId: undefined,
  },
);
const userStore = useUserStore();
const itemStore = useItemStore();
</script>

<style module lang="scss">
.followButton {
  margin-top: 6px;

  @media (--sp) {
    margin-top: 12px;
  }
}
</style>
